var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocket02(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.9999L12 15.9999M16 19.9999C17.8625 19.2916 19.6492 18.3982 21.3333 17.3333M16 19.9999V26.6666C16 26.6666 20.04 25.9333 21.3333 23.9999C22.7733 21.8399 21.3333 17.3333 21.3333 17.3333M12 15.9999C12.7095 14.1592 13.6029 12.3947 14.6667 10.7333C16.2202 8.24924 18.3835 6.20399 20.9507 4.79205C23.5178 3.3801 26.4035 2.64842 29.3333 2.66659C29.3333 6.29326 28.2933 12.6666 21.3333 17.3333M12 15.9999H5.33333C5.33333 15.9999 6.06666 11.9599 8 10.6666C10.16 9.22659 14.6667 10.6666 14.6667 10.6666M5.99999 21.9999C3.99999 23.6799 3.33333 28.6666 3.33333 28.6666C3.33333 28.6666 8.32 27.9999 10 25.9999C10.9467 24.8799 10.9333 23.1599 9.87999 22.1199C9.36174 21.6253 8.67905 21.3394 7.96296 21.3173C7.24687 21.2951 6.54783 21.5382 5.99999 21.9999Z",
    stroke: "#14B8A6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket02);
export default __webpack_public_path__ + "static/media/rocket-02.b00d69ddc71538238b8df087fcb8f551.svg";
export { ForwardRef as ReactComponent };